import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { StyledDay } from '../../core/Calendar/style';
import { showDailyEvent } from '../../../actions/events';

/**
 * Component for showing weekend days in gray. The event "onTouchEnd"
 * is added to be functional in mobile
 */
const FormattedDay = ({ label, date, showDayEvents }) => {
  if (date.getDay() === 6 || date.getDay() === 0) {
    return (
      <StyledDay onTouchEnd={() => showDayEvents({ slots: [date] })}>
        {label}
      </StyledDay>
    );
  }
  return (
    <span onTouchEnd={() => showDayEvents({ slots: [date] })}>{label}</span>
  );
};

FormattedDay.propTypes = {
  label: PropTypes.string,
  date: PropTypes.instanceOf(Date),
  showDayEvents: PropTypes.func
};

const mapDispatchToProps = dispatch => ({
  showDayEvents: slot => showDailyEvent(dispatch, slot)
});

export default connect(
  null,
  mapDispatchToProps
)(FormattedDay);
